import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import * as actions from '../store/options.actions'

export function* setChildbirthOBActionOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getChildbirthActionOptions])
    const { entity } = response
    yield put(actions.setChildbirthOBActionOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setChildbirthOBActionOptions() error: ${e}`))
  }
}
export function* setChildbirthOBActionOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setChildbirthOBActionOptions)
}
